module.exports = __webpack_public_path__ + "img/thumb_17.56ae7459.jpg";